import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {PlinkoPhysicsConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoPhysicConfig";


export class PlinkoObstacleConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoObstacleConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoObstacleConfig, v);
        });
    }

    constructor() {
        super();
        this._key = null;
        this._levelPoints = [];
        this._physicsConfig = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get levelPoints() {
        return this._levelPoints;
    }

    set levelPoints(value) {
        this._levelPoints = value;
    }

    get levelPointsString() {
        if (this.levelPoints) {
            return this.levelPoints.join(";");
        }
        return "";
    }

    set levelPointsString(value) {
        if (!value || value.length === 0) {
            this.levelPoints = [];
        } else {
            this.levelPoints = value.split(";").map(Number).filter(v => v > 0);
        }
    }

    get physicsConfig() {
        return this._physicsConfig;
    }

    set physicsConfig(value) {
        this._physicsConfig = value;
    }

    valid() {
        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (this.levelPoints && this.levelPoints.some(v => !Number.isInteger(v) || v <= 0)) {
            return false;
        }

        if (this.physicsConfig && !this.physicsConfig.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoObstacleConfig());
        } else if (target instanceof PlinkoObstacleConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoObstacleConfig, {
    _key: alias("key", Schema.primitive()),
    _levelPoints: alias("level_points", list(Schema.primitive())),
    _physicsConfig: alias("physics_config", PlinkoPhysicsConfig.schema())
});